import { css } from "@emotion/css";

import { Theme } from "@/modules/theme/utils/createTheme";

export const createStarsRatingStyles = ({ palette }: Theme) => {
  return {
    root: css({
      display: "inline-flex",
      alignItems: "center",
    }),
    active: css({
      color: palette.primary.light,
    }),
    inactive: css({
      color: palette.secondary.main,
    }),
  };
};
